import { Component, OnInit, Input } from '@angular/core';
import { ReportesService, OptionsService } from '../../services/service.index';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import swal2 from 'sweetalert2';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
declare var $;


@Component({
  selector: 'app-reportesolicitudes',
  templateUrl: './reportesolicitudes.component.html',
  styles: []
})
export class ReporteSolicitudesComponent implements OnInit {
  
  constructor( public _reportesservice: ReportesService,
               public router: Router,
               public _optionsservice: OptionsService,
               public http: HttpClient) { }

  doc = new jsPDF();
  facturas: any[] = [];
  usuario: string;
  cols: any[];
  colspdf: any[];
  selectedFac: any[];
  fechaHoy: string;
  // router: Router;
  fileName = 'ListaDeSolicitudes.xlsx';
  selectedColumnsp: any[];
  selectedColumnspdf: any[];
  exportColumns: any[];
  fechaprueba: string;
  fechaprueba2: string;
  _selectedColumns: any[];
  totalOperadoMXN = 0;
  montoNetoMXN = 0;
  totalOperadoUSD = 0;
  montoNetoUSD = 0;

  ngOnInit() {

    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();
   // this.getAcceso('/reportesolicitudes');
   
    this._reportesservice.getReporteSolicitudes()
      .subscribe(resp => {
        this.facturas = resp;
        this.facturas.forEach(factura => {
          const totalOperado = parseFloat(factura.total_operado.replace(',', ''));
          const montoNeto = parseFloat(factura.monto_neto.replace(',', ''));
          if(factura.moneda === 'PESOS'){
            this.totalOperadoMXN += totalOperado;
            this.montoNetoMXN += montoNeto;
          }else if(factura.moneda === 'DOLARES'){
            this.totalOperadoUSD += totalOperado;
            this.montoNetoUSD += montoNeto;
          }
        });
        swal2.close();
                                                                     
    } );

    this.cols = [

    //  { field:  'id_factura', header: 'ID'},
      { field:  'folio_solicitud', header: 'Folio Solicitud'},
      { field:  'cadena', header: 'Empresa' },
      { field:  'deudor', header: 'Deudor'},
      { field:  'estatus', header: 'Estatus'},
      { field:  'fecha_solicitud', header: 'Fecha Solicitud'},
      { field:  'fecha_operacion', header: 'Fecha de operación'},
      { field:  'fecha_vencimiento', header: 'Fecha de vencimiento'},
      { field:  'moneda', header: 'Moneda'},
      { field:  'total', header: 'Total'},
      { field:  'porcentaje_operacion', header: '% Operacion'},
      { field:  'total_operado', header: 'Total Operado'},
      { field:  'saldo', header: 'Saldo'},
      { field:  'intereses', header: 'Intereses'},
      { field:  'monto_neto', header: 'Monto Neto'},
      { field:  'costo_financiero', header: 'Costo Financiero'},
      { field:  'usuario', header: 'Usuario'},
      { field:  'fecha_creacion', header: 'Fecha Creacion'},
      { field:  'fecha_modificacion', header: 'Fecha Modificacion'},
      { field:  'cesion_derechos', header: 'Cesion derechos'},
      { field:  'firma_digital', header: 'Firma digital'},
      { field:  'xml_firma_digital', header: 'XML firma digital'}
  ];

    this._selectedColumns = this.cols;
    this.colspdf = [

    //  { field:  'id_factura', header: 'ID'},
    { field:  'folio_solicitud', header: 'Folio Solicitud'},
    { field:  'cadena', header: 'Empresa' },
    { field:  'deudor', header: 'Deudor'},
    { field:  'estatus', header: 'Estatus'},
    { field:  'fecha_solicitud', header: 'Fecha Solicitud'},
    { field:  'fecha_operacion', header: 'Fecha de operación'},
    { field:  'fecha_vencimiento', header: 'Fecha de vencimiento'},
    { field:  'moneda', header: 'Moneda'},
    { field:  'total', header: 'Total'},
    { field:  'porcentaje_operacion', header: '% Operacion'},
    { field:  'total_operado', header: 'Total Operado'},
    { field:  'saldo', header: 'Saldo'},
    { field:  'intereses', header: 'Intereses'},
    { field:  'monto_neto', header: 'Monto Neto'},
    { field:  'costo_financiero', header: 'Costo Financiero'},
    { field:  'usuario', header: 'Usuario'},
    { field:  'fecha_creacion', header: 'Fecha Creacion'},
    { field:  'fecha_modificacion', header: 'Fecha Modificacion'}
];
    this.selectedColumnsp = this.cols;
    this.exportColumns = this.colspdf.map(col => ({title: col.header, dataKey: col.field}));

  }

  getAcceso(url) {
    let tieneacceso = false;
    this._optionsservice.getOptionsxUsuario(localStorage.getItem('id')).subscribe(resp2 => {
      // tslint:disable-next-line: forin
      for (const j in resp2 ) {
          if ( resp2[j].url === url ) {
            tieneacceso = true;
            break;
          }
        }
      if (!tieneacceso) {
        this.router.navigate(['/accesodenegado']);
      }
    });
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
}

set selectedColumns(val: any[]) {
  // restore original order
  this._selectedColumns = this.cols.filter(col => val.includes(col));
}


  exportexcel() {
    const readOpts = {
      cellText:false, 
      cellDates:true,
    };
    let pos = 3;
     /* table id is passed over here */
     const element = document.getElementById('tablaFacturas');
     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element,readOpts);
     const wj: XLSX.WorkSheet = XLSX.utils.sheet_to_json(ws);
     for (const prop in wj) {
        ws[`S${pos}`].l = { Target:ws[`S${pos}`].v, Tooltip:"" };
        ws[`T${pos}`].l = { Target:ws[`T${pos}`].v, Tooltip:"" };
        ws[`U${pos}`].l = { Target:ws[`U${pos}`].v, Tooltip:"" };
        pos = pos+1;
     }
    // ws['S3'].l = { Target:ws['S3'].v, Tooltip:"Find us @ SheetJS.com!" };
   
     
     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
     /* save to file */
     pos = 3;
     XLSX.writeFile(wb, this.fileName, readOpts);
  }


  exportpdf() {

   import('jspdf').then( jsPDF => {
    import('jspdf-autotable').then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.facturas);
        doc.save('ListaFacturas.pdf');
    });
}); 

  }

  change(){
    const element = document.getElementById('tablaFacturas');
    let tags = element.getElementsByTagName('th');
    const arrTags = Array.from(tags);
    let idColumnaMoneda = arrTags.findIndex(tag => tag.innerText === 'Moneda ');

    let celdas = element.getElementsByTagName('td');
    this.montoNetoMXN = 0;
    this.montoNetoUSD = 0;
    this.totalOperadoMXN = 0;
    this.totalOperadoUSD = 0;

    let j = idColumnaMoneda;
    let idColumna = arrTags.findIndex(tag => tag.innerText === 'Total Operado ');
    for(let i = idColumna; i < celdas.length; i+= idColumna){
      if(celdas[j].innerText === 'PESOS'){
        if(!isNaN(parseFloat(celdas[i].innerText.replace(',', '')))){
          this.totalOperadoMXN += parseFloat(celdas[i].innerText.replace(',', ''));
        }
      }else if(celdas[j].innerText === 'DOLARES'){
        if(!isNaN(parseFloat(celdas[i].innerText.replace(',', '')))){
          this.totalOperadoUSD += parseFloat(celdas[i].innerText.replace(',', ''));
        }
      }
      i += (this._selectedColumns.length-idColumna);
      j += (this._selectedColumns.length-idColumnaMoneda) + idColumnaMoneda;
    }

    j = idColumnaMoneda;
    idColumna = arrTags.findIndex(tag => tag.innerText === 'Monto Neto ');
    for(let i = idColumna; i < celdas.length; i+= idColumna){
      if(celdas[j].innerText === 'PESOS'){
        this.montoNetoMXN += parseFloat(celdas[i].innerText.replace(',', ''));
      }else if(celdas[j].innerText === 'DOLARES'){
        this.montoNetoUSD += parseFloat(celdas[i].innerText.replace(',', ''));
      }
      i += (this._selectedColumns.length-idColumna);
      j += (this._selectedColumns.length-idColumnaMoneda) + idColumnaMoneda;
    }
  }

}
